<div class="next-steps">
  <h1 class="next-steps__title" i18n>What happens next?</h1>
  <div class="next-steps__steps">
    <div class="next-steps__steps__icon next-steps__steps__icon--email"><img ngSrc="assets/images/email.svg" alt="Edit" height="24" width="24" /></div>
    <div class="next-steps__steps__icon__separator next-steps__steps__icon__separator--first"></div>
    <div class="next-steps__steps__icon next-steps__steps__icon--student"><img ngSrc="assets/images/student.svg" alt="Edit" height="24" width="24" /></div>
    <div class="next-steps__steps__icon__separator next-steps__steps__icon__separator--last"></div>
    <div class="next-steps__steps__icon next-steps__steps__icon--flag"><img ngSrc="assets/images/flag.svg" alt="Edit" height="24" width="24" /></div>

    <div class="next-steps__steps__texts next-steps__steps__texts--email" i18n>We'll send your confirmation email</div>
    <div class="next-steps__steps__texts__chevron next-steps__steps__texts__chevron--first">
      <i class="pi pi-chevron-right" aria-hidden="true"></i>
    </div>
    <div class="next-steps__steps__texts next-steps__steps__texts--student" i18n>Receive your induction email</div>
    <div class="next-steps__steps__texts__chevron next-steps__steps__texts__chevron--last">
      <i class="pi pi-chevron-right" aria-hidden="true"></i>
    </div>
    <div class="next-steps__steps__texts next-steps__steps__texts--start-date" i18n>
      Begin your course on {{ courseStartDate() | lxDate : DateFormat.SHORT_MONTH_NAME }}
    </div>
  </div>
</div>
